export class TipoIstanzaFascicoloVO {
  id: string;
  nome: string;
  codice: string;
  output: string;
  dataIstanza: string;
}
